import React from 'react';
import { Box, Typography, Paper, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ruleCardSx } from './stiklainisStyles';

const RULE_KEYS = ['rule1', 'rule2', 'rule3', 'rule4', 'rule5'] as const;

const StiklainisRulesGrid: React.FC = () => {
  const { t } = useTranslation();
  useTheme();

  return (
    <Box sx={{ px: 0 }}>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, mb: 1 }}>
        {t('stiklainis.roomInformationTitle')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {t('stiklainis.rulesSectionTitle')}
      </Typography>

      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
        {RULE_KEYS.map((key, index) => (
          <Paper key={key} elevation={0} sx={ruleCardSx}>
            <Box
              sx={{
                minWidth: 32,
                height: 32,
                borderRadius: '50%',
                bgcolor: 'primary.main',
                color: 'primary.contrastText',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 700,
                fontSize: '0.875rem',
                flexShrink: 0,
              }}
            >
              {index + 1}
            </Box>
            <Typography variant="body1" sx={{ lineHeight: 1.6 }}>
              {t(`stiklainis.${key}`)}
            </Typography>
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default StiklainisRulesGrid;
